import { DOCUMENT } from '@angular/common';
import { Injectable, Injector, inject } from '@angular/core';
import { SnackbarService } from './snackbar.service';

export const APP_VERSION_OUTDATED_STATUS = 426;
export const APP_VERSION_OUTDATED_MESSAGE = 'Nova versão disponível. Recarregue a página.';
export const VERSION_RELOAD_STORAGE_KEY = 'mkg.versionReloadAt';
export const VERSION_RELOAD_WINDOW_MS = 60_000;
export const VERSION_RELOAD_DELAY_MS = 1_500;
const MESSAGE_DURATION_MS = 7_000;
const PERSISTENT_DURATION_MS = 0;

@Injectable({
  providedIn: 'root'
})
export class AppVersionReloadService {

  private readonly _injector = inject(Injector);
  private readonly _document = inject(DOCUMENT);

  private _reloadScheduled = false;
  private _persistentShown = false;

  handleOutdated(): void {
    if (this._reloadScheduled || this._persistentShown) {
      return;
    }
    const now = Date.now();
    const lastReloadAt = this._readReloadAt();
    const reloadedRecently = lastReloadAt !== null && now - lastReloadAt >= 0 && now - lastReloadAt < VERSION_RELOAD_WINDOW_MS;
    if (reloadedRecently || !this._writeReloadAt(now)) {
      this._persistentShown = true;
      this._snackbar().warning(APP_VERSION_OUTDATED_MESSAGE, undefined, undefined, { duration: PERSISTENT_DURATION_MS });
      return;
    }
    this._reloadScheduled = true;
    this._snackbar().warning(APP_VERSION_OUTDATED_MESSAGE, undefined, undefined, { duration: MESSAGE_DURATION_MS });
    setTimeout(() => this._document.defaultView?.location.reload(), VERSION_RELOAD_DELAY_MS);
  }

  private _snackbar(): SnackbarService {
    return this._injector.get(SnackbarService);
  }

  private _readReloadAt(): number | null {
    try {
      const value = Number(this._document.defaultView?.sessionStorage.getItem(VERSION_RELOAD_STORAGE_KEY));
      return Number.isFinite(value) && value > 0 ? value : null;
    } catch {
      return null;
    }
  }

  private _writeReloadAt(timestamp: number): boolean {
    try {
      const storage = this._document.defaultView?.sessionStorage;
      if (!storage) {
        return false;
      }
      storage.setItem(VERSION_RELOAD_STORAGE_KEY, String(timestamp));
      return true;
    } catch {
      return false;
    }
  }
}
